import { useCallback, useEffect, useState, useRef } from 'react';
import styles from './MiniNav.module.css';
import { motifPaths } from '../data/motifs.js'


const beaconMotifPath = motifPaths.observer.path;




function MiniNav({miniNavLinkArray}) {

    return (
        <>
            <div className={styles.miniNav}>
                <a tabIndex="0" title="Navigate back home." href="">
                    <svg className={styles.miniNavMotif}>{beaconMotifPath}</svg>
                </a>
                <div className={styles.miniNavLinks}>
                    {miniNavLinkArray ?
                        miniNavLinkArray.map(item => {
                            return <a tabIndex="0"  title={item.linkTitle} id={item.id} href={item.link} className={styles.miniNavLink + " "
                                + (item.specialLink ? styles.miniNavLinkSpecial : null) + " "
                                + (item.targetUp ? styles.miniNavLinkTargetUp : null)}>
                                {item.linkText}
                            </a>
                        })
                        : null}
                </div>
            </div>
        </>


    );
}

export default MiniNav;
